import React from 'react';

function IsQuickest({ journey }) {
    const content = journey.isQuickest ? <span className="fastest train-user-journey-dest">Fastest</span> : "";

  return content;
}

export default IsQuickest;
